import React from 'react';
import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '../Helmet';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import { FirstAds, SecondAds  } from "../../Ads";
import SharedGPATableConverter from './SharedGPATabelConverter';
const TITLE = 'GPA Conversion Tool: Scale & Table Converter';
const DESCRIPTION = 'Easily convert GPA between different scales including 4.0, 5.0, and percentage systems with our intuitive GPA Conversion Tool.';
const KEYWORDS = 'GPA conversion tool, convert GPA from 5.0 to 4.0, convert GPA from 4.0 to 5.0, convert GPA from percentage to 4.0, GPA scale converter, GPA table conversion';
const OG_URL = 'https://do-calculate.com/calculator/en/gpatableconverter';
function GPATableConverter() {
    return (
        <div className="ltr">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div className="row">
                <FirstAds />
            </div>
            <div className="row">
                <div className="col">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                    <div className="border border-light">
                        <SharedGPATableConverter />
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <SecondAds />
                <br />
                <MainCalculatorsList CalculatorsTypeId={CalculatorsType.studyCalculators}></MainCalculatorsList>
                <br />
            </div>
             <br />
        </div>
    );
}
export default GPATableConverter;
